import React, { Component } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { StaticImage } from 'gatsby-plugin-image';

export default class ProjectSliderHero extends Component {
  // componentDidMount() {}

  render() {
    const settings = {
      dots: false,
      // slidesToShow: 3,
      arrows: false,
      // centerMode: true,
      // speed: 3000,
      // autoplay: true,
      // centerPadding: '50px',
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '30px',
          },
        },
      ],
    };
    // $('.projectSlide').click(function(e) {
    //   $('.projectSlide').slick('slickNext');
    // });
    return (
      <div>
        <Slider {...settings}>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/hero_1.jpg"
              alt="フィーリングサロンHERO"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/hero_3.jpg"
              alt="フィーリングサロンHERO"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/hero_2.jpg"
              alt="フィーリングサロンHERO"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/hero_4.jpg"
              alt="フィーリングサロンHERO"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/hero_5.jpg"
              alt="フィーリングサロンHERO"
              placeholder="blurred"
            />
          </div>
        </Slider>
      </div>
    );
  }
}
